import Image from 'next/image'
import React from 'react'

type InterviewCustomerVoiceProps = {
  company: string
  companyUrl: string
  companyLocation: string
  companyImg: string
  readText: string
  infoText: string
  children: React.ReactNode
}

const InterviewCustomerVoice: React.FC<InterviewCustomerVoiceProps> = ({
  company,
  companyUrl,
  companyImg,
  companyLocation,
  readText,
  infoText,
  children,
}) => {
  return (
    <div className="interview_section" id="about">
      <div className="customer_voice">
        <div className="title">【お客様の声】</div>
        <h1 className="customer_name">{`${company}様（${companyLocation}）`}</h1>
        <div className="read_text">
          <pre>{readText}</pre>
        </div>
        <div className="customer_info">
          <div className="mr-8 sp:mr-0 sp:mb-4">
            <div className="customer_info_name">{`株式会社${company}様について`}</div>
            <div className="customer_info_text">{infoText}</div>
            <a
              className="customer_info_banner hover:opacity-75"
              href={companyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${company}様`}
              <Image
                layout="raw"
                className="linkImg"
                src="/images/youtube_link.png"
                width={20}
                height={13}
                alt=""
              />
            </a>
          </div>
          <div className="customer_info_image">
            <Image
              src={companyImg}
              alt={`${company}dddd様について`}
              height={260}
              width={210}
              layout="raw"
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}

export default InterviewCustomerVoice
